document.addEventListener("DOMContentLoaded", function() {
    console.log("DOM fully loaded and parsed.");
    
    // Wait for the product section to be available
    setTimeout(() => {
        const productSection = document.querySelector(".product-section");
        if (!productSection) {
            console.error("ERROR! No product section found (even after waiting).");
            return;
        }

        console.log("✅ Product section found:", productSection);
        new MainProduct(); // Initialize the MainProduct class
    }, 1000); // Wait 1 second to ensure elements have loaded
});

class WeightSelector extends HTMLElement {
  #variantInputs = null;
  #select = null;
  #productSection = null;
  #selectedSize = null;
  #productVariants = [];
  constructor() {
    super();
  
    this.#productSection = this.closest(".product-section")
    this.#variantInputs = this.#productSection.querySelectorAll(`.variant-wrapper[data-variant-for="size"],.variant-wrapper--dropdown[data-variant-option="size"] select`);
    this.#select =  this.querySelector("select")
    this.#selectedSize = this.#productSection.querySelector(`.variant-wrapper[data-variant-for="size"] input:checked, .variant-wrapper--dropdown[data-variant-option="size"] select`);
    
    if (!this.#selectedSize){
      console.error("There are not available variants");
      return;
    }
    this.getProductVariants()
    this.populateSelect();
    this.onVariantsInputChnage();
    this.classList.remove("not-initialized")
  }

  getProductVariants(){
    const data = this.#productSection.querySelector(".all-product-variants");

    let jsonData;
    try {
      jsonData = JSON.parse(data.innerHTML)
    } catch (e){
      console.error("ERROR! The data from .all-product-variants cannot be fetched: ", e)
    }
    this.#productVariants = [...jsonData]
    
  }

  onVariantsInputChnage(){
    this.#variantInputs.forEach(input => {
      input.addEventListener("change", () => {
        this.#selectedSize = this.#productSection.querySelector(`.variant-wrapper[data-variant-for="size"] input:checked, .variant-wrapper--dropdown[data-variant-option="size"] select`);
        this.populateSelect();
        
      })
    })
    this.onSelectChange();
  }
  populateSelect(){
    const variantsWithSelectedSize = this.#productVariants.filter(el => el.option1 === this.#selectedSize.value && el.available == true )
    //const weightOptions = this.#productSection.querySelectorAll(`.variant-wrapper[data-variant-for="weight"] .variant-input input:not(.disabled)`);
  
    
    this.#select.innerHTML = ""
    let optionValues = [];
    let sumPrice = 0;
    let sumWeight = 0;
    
    variantsWithSelectedSize.forEach((variant, index) => {
      optionValues.push(variant.variant_id);
      sumPrice += parseInt(variant.price)
      sumWeight += parseFloat(variant.option2.replace('g', ''))
      const moneyValue = this.numberWithCommas((sumPrice / 100).toFixed(2))
      const optionEl = document.createElement("option");
      optionEl.value = `${optionValues}`
      optionEl.dataset.moneyValue = moneyValue;
      optionEl.dataset.sumWeight = sumWeight;
      optionEl.textContent = `${index+1} bangle${index > 0 ? 's': ''} for $ ${moneyValue}`
      this.#select.appendChild(optionEl)
    })
    this.selectChangeHandler()
  }

  onSelectChange() {
    this.#select.addEventListener("change", () => {
      this.selectChangeHandler();
    })
  }

  selectChangeHandler(){
    const moneyValue = this.#select.options[this.#select.selectedIndex].dataset.moneyValue;
    const weightValue = this.#select.options[this.#select.selectedIndex].dataset.sumWeight;
      this.#productSection.dispatchEvent(new CustomEvent("quantity-chnaged", {
        detail: {
          variants: this.#select.value.split(","),
          sumPrice: moneyValue,
          weightValue: weightValue
        }
      }))
  }
  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

}

customElements.define("weight-selector", WeightSelector)

class MainProduct {
  productSection = null;
  formData = {
    'items': []
  };
  atcChanged = false;
  constructor(){
    this.productSection = document.querySelector(".product-section");
    if (!this.productSection){
      console.error("ERROR! No product section found")
      return;
    }
    this.productSection.addEventListener("quantity-chnaged", (ev) => {
      this.qtyChange(ev.detail)
    })
    
  };

  qtyChange(data){
    //clear formData
    this.formData.items = [];
    if (!data.variants || data.variants.length == 0){
      console.error("ERROR! no varinats sent to MainProduct");
      return;
    }
    data.variants.forEach(variant => {
      this.formData.items.push({
        'id': parseInt(variant),
        'quantity': 1
      })
    });

    console.log("formdata: ", this.formData);
    
    //change Main price
    const mainPriceField = this.productSection.querySelector(".product__price");
    if (mainPriceField){
      mainPriceField.innerHTML = '$ ' + data.sumPrice
    }

    //change the table below
    const productBlockPrice = this.productSection.querySelector(".product-block--price p");
    if (productBlockPrice){
      productBlockPrice.innerHTML = '$ ' + data.sumPrice
    }

    const productBlocks =  this.productSection.querySelectorAll(".product-block");
    productBlocks.forEach(block => {
      if (block.querySelector('h4') && block.querySelector('h4').innerHTML.toLowerCase().includes('weight')){
        block.querySelector('p').innerHTML = parseFloat(data.weightValue).toFixed(2) + 'g'
      }
    })

    //change Image
    this.selectImage(data.variants.length)

    if(!this.atcChanged){
      const atcButton = this.productSection.querySelector("button.add-to-cart")
      if (!atcButton){
        console.error("ERROR! No ATC button");
        return;
      }
      
      atcButton.addEventListener("click", (e)=>{
        e.preventDefault();
        this.fetchATC();
      })
      this.atcChanged = true;

      const buyButtons = atcButton.nextElementSibling;
      if (buyButtons){
        buyButtons.querySelector("div").style.pointerEvents = "none";
        buyButtons.addEventListener("click", (e) => {
          e.preventDefault();
          this.fetchATC("/checkout");
        })
      }
    }
  }

  fetchATC(url = "/cart"){
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(this.formData)
    })
    .then(response => {
      window.location.href = url;
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    })
  }

  selectImage(imageIndex){
    if (window.screen.availWidth < 769){
       const imgDots = this.productSection.querySelectorAll(".flickity-page-dots li");
      imgDots.forEach((dot, index) => {
        if (index == imageIndex){
          dot.click()
        }
      })
    }
    else {
      const imgThumbs = this.productSection.querySelectorAll(".product__thumb-item a");
      imgThumbs.forEach(thumb => {
        if (thumb.dataset.index == imageIndex){
          thumb.click()
        }
      })
    }
  }
}


document.addEventListener("DOMContentLoaded", function () {
    setTimeout(() => {
        const productSection = document.querySelector(".product-section");
        
        if (!productSection) {
            console.warn("⚠️ WARNING: No product section found. This might not be a product page.");
            return; // Exit the script if it's not a product page
        }

        console.log("✅ Product section found:", productSection);
        new MainProduct(); // Initialize MainProduct class
    }, 1000); // Delay execution by 1 second
});




